import "./AllAnalytics.css";
import React from "react";
import AnalyticsVideo from "./AnalyticsVideo";
import AnalyticsPage from "./AnalyticsPage";
import AnalyticsChat from "./AnalyticsChat";
import { Link, NavLink } from "react-router-dom";

const AllAnalytics = () => {
  return (
    <>
      <div className="main-container techexpressway-container">
        <img
          src="/images/banner-entry.png"
          alt="testimonial-banner-image"
          className="banner-img"
        />
        <nav className="navbar">
          <div className="navbar-container">
            <ul className="nav-menu">
              <li className="nav-item">
                <NavLink
                  to="/home"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/foundation-component"
                  target="_blank"
                  className="nav-links"
                  activeClassName="is-active"
                >
                  Foundation
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/job-readiness"
                  target="_blank"
                  className="nav-links"
                  activeClassName="is-active"
                >
                  Job Readiness
                </NavLink>
              </li>
              <li className="nav-item">
                <a
                  href="https://atci.techleap.accenture.com"
                  className="nav-links"
                  target="_blank"
                >
                  Specialization
                </a>
              </li>
              {/* <li className="nav-item">
                                <NavLink to="/gamification" className="nav-links" activeClassName="is-active" exact={true}>Gamification</NavLink>
                            </li> */}
              <li className="nav-item">
                <NavLink
                  to="/techexpressway-faq"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  FAQs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/Testimonials"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Testimonials
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/analytics"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Analytics
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>

        <div className="all-analytics">
          <div className="user-analytics">
            <AnalyticsPage />
          </div>
          <div className="videos-analytics">
            <AnalyticsVideo />
          </div>
          <div className="chat-analytics">
            <AnalyticsChat />
          </div>
        </div>
      </div>
    </>
  );
};

export default AllAnalytics;
